import { render, staticRenderFns } from "./InstanceCreditQuotaEditDialog.vue?vue&type=template&id=769b3b88&"
import script from "./InstanceCreditQuotaEditDialog.vue?vue&type=script&lang=js&"
export * from "./InstanceCreditQuotaEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports